import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  // timeout: 30000,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("cria-web@token");

    if (token && token !== "" && JSON.parse(token) !== null) {
      config.headers.Authorization = `Bearer ${JSON.parse(token)}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    const isLoginRoute = originalRequest.url.includes("/controller/auth/login/");
    if (error.response?.status === 401 && !originalRequest._retry && !isLoginRoute) {
      originalRequest._retry = true;

      try {
        const refreshToken = JSON.parse(localStorage.getItem("cria-web@refreshToken"));

        if (!refreshToken) {
          throw new Error("Seu token expirou. Por favor, faça login novamente ou procure seu coordenador.");
        }

        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/controller/auth/login/refresh/`,
          { refresh: refreshToken }
        );

        const { access, refresh: newRefreshToken } = response.data;

        localStorage.setItem("cria-web@token", JSON.stringify(access));
        localStorage.setItem("cria-web@refreshToken", JSON.stringify(newRefreshToken));

        api.defaults.headers.common["Authorization"] = `Bearer ${access}`;

        return api(originalRequest);
      } catch (refreshError) {
        console.error("Erro ao renovar token:", refreshError);

        localStorage.removeItem("cria-web@token");
        localStorage.removeItem("cria-web@refreshToken");

        return Promise.reject({
          message: "Sessão expirada. Por favor, procure seu coordenador ou faça login novamente.",
        });
      }
    }

    return Promise.reject(error);

  }
);

export default api;
